import { Person } from '@app/core/stingray-api/models';
import { ApplicantView } from './applicant-view';
import { FormControl } from '@angular/forms';

export class PersonApplicantView extends ApplicantView {

  person: Person;
  isTaxPartnerApplicantControl: FormControl;

  constructor() {
    super();
    this.type = 'Person';
  }

  isValid(): boolean {
    // getFormValidationErrors(this.form).forEach(err => console.log(this.name, err));
    return this.form.valid;
  }
}
